import { put, takeLatest, call } from "redux-saga/effects";
import {
    GET_REJECTED_AGGREGATORS_FOR_CARRIER,
    GET_REJECTED_AGGREGATORS_FOR_CARRIER_SUCCESS,
    GET_REJECTED_AGGREGATORS_FOR_CARRIER_FAILED,
} from "../../actions/ActionType";
import { API_ENDPOINT } from "../../URLs/ApiEndpoints";
import { makeSecuredPostRequest } from "../../../appApi/AppApi";
import { createActionOf } from "../../actions/ActionCreator";

const TAG = "getRejectedAggregatorsForCarrierSaga.js";

function* workerGetRejectedAggregatorsForCarrier(payLoad) {
  try {
    const response = yield call(
        makeSecuredPostRequest,
        API_ENDPOINT.GET_REJECTED_AGGREGATORS_FOR_CARRIER,
    );
    yield put(createActionOf(GET_REJECTED_AGGREGATORS_FOR_CARRIER_SUCCESS, 1, response));
  } catch (error) {
    console.error(TAG, "Worker get country failed: " + error.message);
    yield put(createActionOf(GET_REJECTED_AGGREGATORS_FOR_CARRIER_FAILED, 2, error));
  }
}

export const watchGetRejectedAggregatorsForCarrier = takeLatest(
    GET_REJECTED_AGGREGATORS_FOR_CARRIER,
    workerGetRejectedAggregatorsForCarrier,
);